
export default function UndoIcon(props) {
    return(    
        <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <path d="M9 14l-5-5 5-5" />
            <path d="M4 9h8a7 7 0 1 1 0 14" />
        </svg>
    );
}